import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import {
  Dialog, DialogSurface, DialogBody, DialogTitle, DialogContent, DialogActions, Button, Text, makeStyles, tokens,
} from '@fluentui/react-components';
import { useT } from '../../i18n';

const useStyles = makeStyles({
  body: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' },
  qr: { width: '240px', height: '240px', backgroundColor: '#fff', padding: '8px', borderRadius: tokens.borderRadiusMedium },
});

/** Muestra un código QR con la página actual para abrirla en el celular. Se genera en el navegador. */
export function PhoneQrDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const s = useStyles();
  const t = useT();
  const [dataUrl, setDataUrl] = useState<string | null>(null);
  const url = window.location.href;

  useEffect(() => {
    if (!open) return;
    let cancelled = false;
    QRCode.toDataURL(url, { width: 480, margin: 1 })
      .then((d: string) => { if (!cancelled) setDataUrl(d); })
      .catch(() => { if (!cancelled) setDataUrl(null); });
    return () => { cancelled = true; };
  }, [open, url]);

  return (
    <Dialog open={open} onOpenChange={(_, d) => { if (!d.open) onClose(); }}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{t.footer.qrTitle}</DialogTitle>
          <DialogContent className={s.body}>
            {dataUrl && <img className={s.qr} src={dataUrl} alt={t.footer.qrTitle} />}
            <Text size={200}>{t.footer.qrHint}</Text>
          </DialogContent>
          <DialogActions>
            <Button appearance="primary" onClick={onClose}>{t.footer.qrClose}</Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
